export default function saveFile(content: any, filename: string, type: string) {
  const url = window.URL.createObjectURL(new Blob([JSON.stringify(content)], {type}));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
}
